export class RssTypeCode {

  /**
   * The Constant SERVICING_REMT_CD.
   */
  static readonly SERVICING_REMT_CD = 'SVCTR';
  /**
   * The Constant PURCHASING_REMT_CD_HECM.
   */
  static readonly PURCHASING_REMT_CD_HECM = 'PRCH1';
  /**
   * The Constant PURCHASING_REMT_CD_HKM.
   */
  static readonly PURCHASING_REMT_CD_HKM = 'PRCH2';

  //This is to be removed as soon as the RSSRemitDAO is corrected
  //to use the new codes for purchase PRCJ1 and PRCH2
  /**
   * The Constant PURCHASING_REMT_CD.
   */
  static readonly PURCHASING_REMT_CD = 'PCHTR';
  /**
   * The Constant PREMIUM_PRICING_REMT_CD.
   */
  static readonly PREMIUM_PRICING_REMT_CD = 'PREMP';
  /**
   * The Constant PREMIUM_PRICING_ADJ_INC.
   */
  static readonly PREMIUM_PRICING_ADJ_INC = 'PREMP_INC';
  /**
   * The Constant PREMIUM_PRICING_ADJ_DEC.
   */
  static readonly PREMIUM_PRICING_ADJ_DEC = 'PREMP_DEC';
  /**
   * The Constant POST_PURCHASE_REMT_CD.
   */
  static readonly  POST_PURCHASE_REMT_CD = 'PCHAJ';
  /**
   * The Constant POST_PURCHASE_ADJ_INC.
   */
  static readonly  POST_PURCHASE_ADJ_INC = 'PCHAJ_INC';
  /**
   * The Constant POST_PURCHASE_ADJ_DEC.
   */
  static readonly  POST_PURCHASE_ADJ_DEC = 'PCHAJ_DEC';
  /**
   * The Constant SCHD_PMT_REMT_CD.
   */
  static readonly SCHD_PMT_REMT_CD = 'SCHPT';
  /**
   * The Constant MIP_SRVR_FEE_REMT_CD.
   */
  static readonly MIP_SRVR_FEE_REMT_CD = 'MIPSF';
  /**
   * The Constant SEAS_LN_FEE_REMT_CD.
   */
  static readonly SEAS_LN_FEE_REMT_CD = 'SSNLN';
  /**
   * The Constant WAIVER_REMT_CD.
   */
  static readonly WAIVER_REMT_CD = 'WAIVR';
  /**
   * The Constant SSNLN_WAIVER_REMT_CD.
   */
  static readonly SSNLN_WAIVER_REMT_CD = 'SSNLNWAIVR';
  /**
   * The Constant REPUR_WAIVER_REMT_CD.
   */
  static readonly REPUR_WAIVER_REMT_CD = 'REPURWAIVR';
  /**
   * The Constant REPUR_FEE_REMT_CD.
   */
  static readonly REPUR_FEE_REMT_CD = 'REPCH';
  /**
   * The Constant PURCHASE_ADJ_REMT_CD.
   */
  static readonly PURCHASE_ADJ_REMT_CD = 'PCHAJ';

  /**
   * The Constant REGULAR_TRAN_CODE.
   */
  static readonly REGULAR_TRAN_CODE = '00';
  /**
   * The Constant POSITIVE_TRAN_CODE.
   */
  static readonly POSITIVE_TRAN_CODE = '01';
  /**
   * The Constant NEGATIVE_TRAN_CODE.
   */
  static readonly NEGATIVE_TRAN_CODE = '02';
  /**
   * The Constant WAIVR_TRAN_CODE.
   */
  static readonly WAIVR_TRAN_CODE = '03';

  /**
   * The Constant SENT_TO_RSS_FLAG_NO.
   */
  static readonly SENT_TO_RSS_FLAG_NO = 'N';
  /**
   * The Constant SENT_TO_RSS_FLAG_YES.
   */
  static readonly SENT_TO_RSS_FLAG_YES = 'Y';


}
